import Vue from 'vue'
import Vuex from 'vuex'
import card from '@/store/modules/card'
import initials from '@/store/modules/initials'
import language from '@/store/modules/language'
import firstName from '@/store/modules/firstName'
import lastName from '@/store/modules/lastName'
import expirationDate from '@/store/modules/expirationDate'
import paronMember from '@/store/modules/paronMember'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    card,
    initials,
    language,
    firstName,
    lastName,
    expirationDate,
    paronMember
  },
  getters
})
